// Libraries

// Supermove
import {gql} from '@supermove/graphql';
import {StageModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

// Shared
import StageForm, {StageFormType} from '@shared/modules/Project/forms/StageForm';

export type ReorderStagesFormType = {
  stageForms: StageFormType[];
};

const edit = withFragment(
  (stages: StageModel[]): ReorderStagesFormType => ({
    stageForms: stages.map((stage) => StageForm.edit(stage)),
  }),
  gql`
    ${StageForm.edit.fragment}

    fragment ReorderStagesForm_edit on Stage {
      id
      ...StageForm_edit
    }
  `,
);

const toMutation = ({stageForms}: ReorderStagesFormType): ReorderStagesFormType => ({
  stageForms: stageForms.map((stageForm) => StageForm.toMutation(stageForm)),
});

const ReorderBillsForm = {
  edit,
  toMutation,
};

export default ReorderBillsForm;
